export const DEFAULT_PANE_WIDTH = 256;
export const DEFAULT_PANE_HEIGHT = 192;
export const DEFAULT_TEMPLATE_PANE_WIDTH = 384;
export const DEFAULT_TEMPLATE_PANE_HEIGHT = 352;
export const DEFAULT_LLM_PANE_HEIGHT = 368;
export const DEFAULT_FUNCTION_PANE_WIDTH = 224;
export const DEFAULT_FUNCTION_PANE_HEIGHT = 160;

export const SOCKET_POKE_MESSAGE = "p";
export const SOCKET_PING_MESSAGE = "_";
export const SOCKET_PROTOCOL_VERSION = 1;
export enum SocketCloseCodes {
  UnsupportedVersion = 4001,
  Unauthorized = 4002,
  CanvasNotFound = 4003,
  InviteRevoked = 4004,
}

export const UNKNOWN_CLIENT_ID = -1;
export const STATE_PANE_GETTER_OUTPUT_INDEX = 2;

export const LLM_INPUT_ID = "input";
export const LLM_OPENAI_CONFIG_DEFAULT_VALUES = {
  temperature: 0.7,
  max_tokens: 256,
};

export const DEFAULT_LIBRARY_PANE_NAME = "natto";
